import { useParams } from 'react-router-dom';
import DetailsEpaysage from '@repo/ui/features/inventaires/epaysage/details';
import { useRouter } from '@repo/ui/hooks/use-router';

export default function EpaysageDetailsPage() {
  const { id = '' } = useParams<{ id?: string }>();
  const router = useRouter();
  const inventaireId = Number(id);

  if (Number.isNaN(inventaireId)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <h1 className="text-2xl font-semibold text-foreground">Inventaire introuvable</h1>
          <p className="text-sm text-muted-foreground">
            L&apos;identifiant fourni n&apos;est pas valide. Veuillez revenir à la liste des inventaires.
          </p>
          <button
            onClick={() => router.push('/admin/inventaires')}
            className="px-4 py-2 text-sm rounded-md bg-primary text-white hover:bg-primary transition-colors"
          >
            Retour à la liste
          </button>
        </div>
      </div>
    );
  }

  return (
    <DetailsEpaysage inventaireId={inventaireId} />
  );
}


